export default function authHeader() {
  const userKey = sessionStorage.userInfo && JSON.parse(sessionStorage.userInfo).user_key;

  let headers = { "Content-Type": "application/json" };

  if (userKey?.length) {
    return { ...headers, "user-key": userKey };
  } else {
    return headers;
  }
}
